<template>
    <section>
        <PageTitle title="All Riders" v-bind:crumbs="[{href:'/home',title:'Home'},{href:'/customers',title:'riders'}]" />
        <div class="wrapper wrapper-content animated fadeInRight">
            <div class="row">
                <div class="col-lg-12">
                    <div class="ibox-title">
                        <h5 class="pull-left">All Riders</h5>
                        <a v-if="userRole!=='ROLE_AGENT'" v-on:click="loadEmptyCustomer()" class="pull-right" >Add New Riders</a>
                    </div>
                    <div class="ibox-content">
                        <div class="row" v-if="!isBranchUser">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Warehouse</label>
                                    <multiselect id="filter1" v-model="selectedRestaurant" :options="restaurants" label="name" track-by="name" @input="fetchBranchesOfRestaurant()"></multiselect>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Vendors</label>
                                    <multiselect id="filter2" v-model="selectedBranch" :options="branches" :custom-label="opt=> opt.areasByAreaId.name" track-by="id"></multiselect>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <button style="margin-top: 25px;margin-right: 10px" class=" btn btn-primary btn-sm search_filter_order_btn"><i class="fa fa-search"></i> Search</button>
                                <button style="margin-top: 25px" class=" btn btn-info btn-sm refresh_filter_order_btn"><i class="fa fa-refresh"></i> Refresh</button>
                            </div>
                        </div>
                        <hr v-if="!isBranchUser"/>
                        <div class="table-responsive">
                            <table class="table table-striped table-responsive table-bordered table-hover" id="dtTable">
                                <thead>
                                    <tr>
                                        <th>Rider ID</th>
                                        <th>Name</th>
                                        <th>Contact</th>
                                        <th>Vehicle Number</th>
                                        <th>Warehouse</th>
                                        <th>Vendor</th>
                                        <th>User Name</th>
                                        <th>Created</th>
                                        <th>Modified</th>
                                        <th>Enabled</th>
                                        <th class="text-center"><i class="fa fa-bolt"></i></th>
                                    </tr>
                                </thead>
                                <tbody></tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ViewCustomerAddresses where="customers" ref="viewCustomerAddressPopUp"/>
        <AddUpdateRider ref="addUpdateRiderPopUp"/>
        <UpdateUsersPassword ref="updateUserPasswordPopUp"/>
    </section>
</template>

<script>
    /* eslint-disable */
    import PageTitle from '@/components/layout_components/PageTitle'
    import ViewCustomerAddresses from '@/components/customers/ViewCustomerAddresses'
    import AddUpdateRider from '@/components/riders/AddUpdateRider'
    import Multiselect from 'vue-multiselect'
    import User from '@/services/User'
    import UpdateUsersPassword from '@/components/users/UpdateUsersPassword'

    export default {
        name: "Riders",
        components: {
            PageTitle,
            ViewCustomerAddresses,
            AddUpdateRider,
            Multiselect,
            UpdateUsersPassword
        },
        data() {
            return {
                selectedRestaurant:'',
                selectedBranch:'',
                restaurants:[],
                branches:[],
                table:'',
                userRole:''
            }
        },
        mounted: function (){
                let user = this.$store.state.user;
                this.userRole = user.userRolesById[0].role;
                if(this.userRole === 'ROLE_ADMIN' || this.userRole ==='ROLE_AGENT'){
                    console.log("in admin");
                    this.$http.post(this.$store.state.mainAppURL + "restaurants/get_all_restaurants").then(resp => {
                        this.restaurants = resp.data;
                    });
                }else if(this.userRole === 'ROLE_USER'){
                    this.selectedRestaurant = this.$store.state.user.restaurant;
                    this.restaurants.push({id: this.$store.state.user.restaurant.id, name: this.$store.state.user.restaurant.name});
                    this.fetchBranchesOfRestaurant();
                }
                console.log(this.where);

            let self = this;
            let processingURL = this.$store.state.mainAppURL + "riders/get_all_riders";
            let dtTable = $('#dtTable').DataTable({
                "processing": true,
                "serverSide": true,
                "searching": true,
                autoWidth: false,
                "lengthMenu": [10, 25, 50, 100, 250],
                "initComplete": function () {
                var api = this.api();
                if ( self.userRole==='ROLE_AGENT' ) {
                    api.column(10).visible( false );
                }},
                "order": [[0, "desc"]],
                'language': {
                    //'loadingRecords': 'Please wait - loading...',
                    'processing': '<div class="sk-spinner sk-spinner-double-bounce">\n' +
                        '                <div class="sk-double-bounce1"></div>\n' +
                        '                <div class="sk-double-bounce2"></div>\n' +
                        '              </div>'
                },
                "ajax": {
                    url: processingURL,
                    type: "post",
                    data: function ( d ) {
                        if (user.userRolesById[0].role==="ROLE_USER"){
                            Object.assign(d, {restaurant_id: user.restaurant.id});
                        }
                        return JSON.stringify( d );
                    },
                    headers: {
                        "Content-type": "application/json; charset=utf-8"
                    },
                    beforeSend:  (xhr) => {
                        xhr.setRequestHeader('Authorization', 'Bearer ' + this.$store.state.accessToken);
                    },
                    statusCode: {
                      401: () => {
                        this.updateRefreshTokenInDataTable(dtTable);
                      }
                    }
                },
                "columnDefs": [
                    { "orderable": false, "targets": [1,2,3,4,5,6,9,10] },
                    { 'className': "text-center", 'aTargets': [0,1,2,3,4,5,6,7,8,9]},
                ],
                "columns": [
                    { "data": "id", "name":"id" },
                    { "data": "name","name":"name" },
                    {
                        "data": "contact","name":"contact",
                        "render": function(data){
                            return (data === null) ? "N/A" : data;
                        }
                    },
                    {
                        "data": "vehicleNumber","name":"Vehicle Number",
                        "render": function(data){
                            return (data === null) ? "N/A" : data;
                        }
                    },
                    {
                        "data": "userId","name":"Restaurant Name",
                        "render": function(data){
                            return (data === null) ? "N/A" : data.restaurant.name;
                        }
                    },
                    {
                        "data": "userId","name":"Vendor Name",
                        "render": function(data){
                            return (data === null) ? "N/A" : data.branch.areasByAreaId.name;
                        }
                    },
                    {"data": "userId.username", "name": "User Name"},
                    {
                        "data": "created",
                        "name":"created",
                        "render": function (data) {
                            return "<span class='m_tip label label-default'>"+self.formatDate(String(data))+"</span>";
                        }
                    },
                    {
                        "data": "modified",
                        "name":"modified",
                        "render": function (data) {
                          return "<span class='m_tip label label-default'>"+self.formatDate(String(data))+"</span>";
                        }
                    },
                    {
                      "data": "deleted",
                      "name": "Deleted",
                      "render": function(data){
                        if(!data){
                          return "<label class='label label-success'>Yes</label>"
                        }else{
                          return "<label class='label label-danger'>No</label>"
                        }
                      }
                    },
                    {
                        "data": "action","name":"action",
                        "render": function(data, type, row) {
                          let actions = "";
                          if (row.deleted) {
                            actions += "<a data-id='" + row.id + "' class='enableRider'><i title='Enable Rider' class='fa fa-check fa-lg'></i></a>";
                          } else {
                            actions += "<a data-id='" + row.id + "' class='deleteRiderBtn'><i title='Delete' class='fa fa-trash fa-lg'></i></a>";
                          }
                          actions += "|<a data-id='" + row.id + "' class='updateRiderBtn'><i title='Update' class='fa fa-pencil fa-lg'></i></a>";
                          if (row.userId !== null && !self.isBranchUser) {
                            actions += "|<a data-id='" + row.userId.id + "' class='updatePasswordBtn'><i title='Update Password' class='fa fa-lock fa-lg'></i></a> ";
                          }
                          return actions;
                        }
                    }
                ],
                "drawCallback": function( settings ) {
                    $(".m_tip").tooltip();
                    $(".updateRiderBtn").click(function () {
                        let riderId = $(this).attr("data-id");
                        self.$refs.addUpdateRiderPopUp.load(riderId);
                    });
                    $(".updatePasswordBtn").click(function() {
                        let userId = $(this).attr("data-id");
                        self.$refs.updateUserPasswordPopUp.load(userId);
                    });
                    $(".enableRider").click(async function () {
                      let userId = $(this).attr("data-id");
                      await self.$http.get(self.$store.state.mainAppURL + "riders/enable_rider/" + userId);
                      dtTable.draw();
                      swal("SUCCESS!", "Rider has been enabled successfully!", "success");
                    });
                    $(".deleteRiderBtn").click(function () {
                        let riderId = $(this).attr("data-id");
                        Swal({
                            title: 'Are you sure?',
                            text: "Are you sure you want to delete this rider!",
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#1ab394',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Yes, delete it!'
                        }).then((result) => {
                            if (result.value) {
                                self.$http.delete( self.$store.state.mainAppURL + "riders/"+riderId).then(resp => {
                                    Swal.close();
                                    if(resp.data){
                                        dtTable.draw();
                                        swal("SUCCESS!", "Rider has been deleted successfully!", "success");
                                    }else{
                                        swal("Error!", "Please try again!", "error");
                                    }
                                }).catch(ex => {
                                    this.showErrorMessage(ex);
                                });
                            }
                        });
                    });
                },
                "tableTools": {
                    "sSwfPath": "js/plugins/dataTables/swf/copy_csv_xls_pdf.swf"
                }
            });
            this.table = dtTable;
            $.fn.dataTable.ext.errMode = 'none';
            $(".search_filter_order_btn").click(function(){
                dtTable.search('');
                if (self.selectedRestaurant!=='') {
                  dtTable.column(4).search(self.selectedRestaurant.name);
                }if(self.selectedBranch !== '') {
                  dtTable.column(5).search(self.selectedBranch.id);
                }
                dtTable.draw();
                self.branches = [];
            });
            $(".refresh_filter_order_btn").click(function() {
                dtTable.search('');
                dtTable.column(4).search('');
                dtTable.column(5).search('');
                dtTable.draw();
                self.selectedRestaurant = '';
                self.selectedBranch = '';
                self.branches = [];
            });
            let dtTableFilterSelector = $("#dtTable_filter input");
            dtTableFilterSelector.unbind();
            dtTableFilterSelector.attr("size","35");
            dtTableFilterSelector.attr("placeholder", "Search on name, vendor, vehicle no. or contact....");
            dtTableFilterSelector.keyup(function (e) {
                if(e.keyCode === 13) {
                    dtTable.search($(this).val()).draw();
                }
            });
        },
        computed: {
          isBranchUser(){
            return this.$store.state.user.userRolesById[0].role === 'ROLE_BRANCH'
          }
        },
        methods:{
            tableDraw: function () {this.table.draw()},
            fetchBranchesOfRestaurant: function () {
                let params = new URLSearchParams();
                params.append("restaurant_id", this.selectedRestaurant.id);
                if(this.selectedRestaurant !== "all"){
                    this.$http.post(this.$store.state.mainAppURL + "restaurants/get_all_branches", params).then(resp => {
                        console.log(resp.data);
                        this.branches = resp.data;
                    });
                }else{
                    this.selectedBranch = "all";
                    this.branches = [];
                }
            },
            loadEmptyCustomer: function () {
                this.$refs.addUpdateRiderPopUp.load(0);
            }
        }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>

</style>
